import React from "react";
import { PhoneCall, PhoneMissed, FileText, Mail } from "lucide-react";
import { LeadStatus, LeadType, LeadOutcome } from "./types/LeadTypes";

export const getLeadTypeIcon = (type: LeadType, status: LeadStatus) => {
  if (type === "Call") {
    if (status === "Call Missed") {
      return <PhoneMissed size={13} className="text-red-500" />;
    } else if (status === "Call Returned") {
      return <PhoneCall size={13} className="text-black" />;
    } else if (status === "Call Answered") {
      return <PhoneCall size={13} className="text-black" />;
    }
    return <PhoneCall size={13} className="text-black" />;
  } else {
    if (status === "Form Received") {
      return <FileText size={13} className="text-black" />;
    } else if (status === "Form Replied") {
      return <Mail size={13} className="text-black" />;
    }
    return <FileText size={13} className="text-black" />;
  }
};

export const getLeadTypeText = (status: LeadStatus) => {
  return status;
};

export const getLeadTypeColor = (status: LeadStatus) => {
  if (status.includes("Missed")) {
    return "text-red-500";
  }
  return "text-black";
};

export const getOutcomeCircleColor = (outcome: LeadOutcome | null): string => {
  if (!outcome) return "#f3f4f6"; // default light gray

  if (outcome === "Existing Customer") {
    return "#0EA5E9"; // blue for existing customer
  } else if (
    outcome.startsWith("Sale Won") ||
    outcome.startsWith("Appointment Set")
  ) {
    return "#22c55e"; // green-500 for positive outcomes
  } else if (outcome === "Lead Will Call Back") {
    return "#FFC107"; // yellow for "Lead will Call Back"
  } else if (
    outcome === "Unknown" ||
    outcome.startsWith("Call Back Requested") ||
    outcome.startsWith("Research / Price Shopping")
  ) {
    return "#FFC107"; // amber/yellow for pending/unknown outcomes
  } else if (outcome.startsWith("Disqualified")) {
    return "#ef4444"; // red-500 for disqualified outcomes
  } else if (outcome.startsWith("Lost")) {
    return "#9CA3AF"; // gray-400 for lost opportunities
  } else {
    return "#f3f4f6"; // default light gray
  }
};

export const getFilteredStatusOptions = (type: LeadType) => {
  if (type === "Call") {
    return ["Call Answered", "Call Missed", "Call Returned"];
  } else {
    return ["Form Received", "Form Replied"];
  }
};
